export default "__VITE_ASSET__DWEaPx6U__"